import { featureAccessStore } from 'stores/featureAccessStore'

export const setFeatureAccess = (featureAccessData: any[]) => {
  // Temporary variables for combined feature flags
  let COMMUNICATIONS_PUSHNOTIFICATIONS = false
  let COMMUNICATIONS_BANNERMESSAGES = false

  // Loop through each feature access and set the store values
  featureAccessData?.forEach((feature) => {
    switch (feature.featureType?.toUpperCase()) {
      case 'UNKNOWN':
        featureAccessStore.setState({ unknown: feature.allowed ?? false })
        break
      case 'PATRON':
        featureAccessStore.setState({ patron: feature.allowed ?? false })
        break
      case 'CHECKIN':
        featureAccessStore.setState({ checkin: feature.allowed ?? false })
        break
      case 'TIERS':
        featureAccessStore.setState({ tiers: feature.allowed ?? false })
        break
      case 'SPECIALSANDEVENTS':
        featureAccessStore.setState({
          specialsAndEvents: feature.allowed ?? false,
        })
        break
      case 'REWARDS_JJ':
        featureAccessStore.setState({ rewardsJJ: feature.allowed ?? false })
        break
      case 'REWARDS_LOCATION':
        featureAccessStore.setState({
          rewardsLocation: feature.allowed ?? false,
        })
        break
      case 'SWEEPSTAKES_JJ':
        featureAccessStore.setState({ sweepstakesJJ: feature.allowed ?? false })
        break
      case 'SWEEPSTAKES_LOCATION':
        featureAccessStore.setState({
          sweepstakesLocation: feature.allowed ?? false,
        })
        break
      case 'COMMUNICATIONS_PUSHNOTIFICATIONS':
        COMMUNICATIONS_PUSHNOTIFICATIONS = feature.allowed ?? false
        featureAccessStore.setState({
          communicationsPushNotifications: COMMUNICATIONS_PUSHNOTIFICATIONS,
        })
        break
      case 'COMMUNICATIONS_BANNERMESSAGES':
        COMMUNICATIONS_BANNERMESSAGES = feature.allowed ?? false
        featureAccessStore.setState({
          communicationsBannerMessages: COMMUNICATIONS_BANNERMESSAGES,
        })
        break
      default:
        break
    }
  })

  // Set any other feateure variables based on combinations of flags
  // For use when needing to check multiple feature flags so the code can check one variable instead of many
  featureAccessStore.setState({
    noCommunications:
      !COMMUNICATIONS_PUSHNOTIFICATIONS && !COMMUNICATIONS_BANNERMESSAGES,
  })
}
